import QueryString from 'qs';
import { api } from '../../config';
import store from '../../store';
import { selectExpressions } from '../../store/selector/selectExpressions';
import { selectGlobalConstants } from '../../store/selector/selectGlobalConstants';
import { selectJWT } from '../../store/selector/selectJWT';
import { selectLocale } from '../../store/selector/selectLocale';
import { selectMe } from '../../store/selector/selectMe';
import { selectCustomStates } from '../../store/selector/selectStates';
import actions from '../../utils/actions';
import { TMutationContext } from './types';
import { constructExpressions } from './constructExpressions';
import { selectDictionaries } from '../../store/selector/selectDictionaries';

export const constructContexts = (): Partial<TMutationContext> => {
  const state = store.getState();
  return {
    me: selectMe(state),
    jwt: selectJWT(state),
    locale: selectLocale(state),
    states: selectCustomStates(state),
    exp: constructExpressions(selectExpressions(state)),
    fn: actions,
    document: {
      serverHost: api.host,
      host: document.location.host,
      pathname: document.location.pathname,
      params: {},
      query: QueryString.parse(document.location.search?.slice(1)),
    },
    constants: selectGlobalConstants(state),
    dictionaries: selectDictionaries(state),
  };
};
